export default {
  xsmall: '(min-width: 480px)',
  small: '(min-width: 762px)',
  medium: '(min-width: 992px)',
  large: '(min-width: 1200px)',
  xlarge: '(min-width: 1400px)',
  xxlarge: '(min-width: 2200px)',
};
